<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 150px; top: 106px;")
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Inventory
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/services')") Services
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/packages')") Packages
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/stocktakes')") Stock take
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="company.is_hq || company.branch_of" @click="$router.push('/admin/clinic/branches-warehouses')") Branches & Warehouses
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/locations')") Locations
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="Auth('root', 'subscribe_purchase_hub')" @click="$router.push('/admin/clinic/inventory-list')") List
    v-col.grow
      v-container.py-8(fluid)
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="neutral700" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Inventory
        v-row.pb-2.pb-md-0(no-gutters)
          v-col(cols="12" md="8")
            v-tabs(v-model="tabs" color="basic700" :height="44" active-class="font-semibold" @change="tabChanged(tabs)")
              v-tab.text-sm.font-medium.text-none.unset-min-width {{ $t('all') }}
              v-tab.text-sm.font-medium.text-none.unset-min-width In-stock
              v-tab.text-sm.font-medium.text-none.unset-min-width Reserved
              v-tab.text-sm.font-medium.text-none.unset-min-width Low stock
              v-tab.text-sm.font-medium.text-none.unset-min-width Out of stock
              v-tab.text-sm.font-medium.text-none.unset-min-width Expiring soon
              v-tab.text-sm.font-medium.text-none.unset-min-width Archived
          v-col(cols="12" md="4" align="end")
            .d-flex.align-center
              v-spacer
              v-btn(@click="clickSearch" icon color="neutral500")
                v-icon(size="20") $yzi-search-sm
              v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
              div
                customize-column-menu(type="inventory" :showTooltip="false" iconSize="21")
              template(v-if="!showSearchField")
                //- y-button.ml-3(label="Stock update" size="sm" button-class="px-3" outlined @click="bulkStockUpdate")
                v-menu(offset-y left rounded="lg")
                  template(v-slot:activator="{ on }")
                    div(v-on="on")
                      y-button.ml-3(label="Price list" size="sm" button-class="px-3" append-icon="$yzi-download-02" icon-size="16" outlined :loading="isDownloading" :disabled="!canDownload")
                  v-list(dense)
                    v-list-item(@click="onDownload('pdf')")
                      v-list-item-content
                        v-list-item-title.text-sm.neutral700--text PDF
                    v-list-item(@click="onDownload('csv')")
                      v-list-item-content
                        v-list-item-title.text-sm.neutral700--text CSV
              y-button.ml-3(v-if="!company.branch_of || canCreateInventory" label="Add new" size="sm" button-class="px-3" @click="addNewMedicine")
        v-divider

        filter-row.my-2(ref="filter" :filters.sync="filters" :prop-filters="saveFilters")
        v-skeleton-loader.mt-sm-4.pb-6(v-if="isFetching" type="table-tbody")
        .data-table(v-else)
          v-data-table.mt-sm-4.pb-6(:headers="headers" :items="medicines" item-key="id" :items-per-page="pageSize" hide-default-footer :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" :server-items-length="totalCount" @update:sort-by="sortBy = $event" @update:sort-desc="sortIsDesc = $event" @click:row="editMedicine")
            //- name
            template(v-slot:item.name="{ item }")
              .d-flex.align-center.justify-space-between
                .yz-medium-body-sm.neutral700--text {{ item.product.name }}
                yz-badge(v-if="item.product.branch_for" x-small color="blue-100" text-color="blue-500" border) HQ
            //- category
            template(v-slot:item.category="{ item }")
              .text-sm.neutral700--text.capitalize {{ item.category }}
            //- groups
            template(v-slot:item.groups="{ item }")
              yz-truncated-list(v-if="item.groups && item.groups.length" :items="item.groups" text-item="value" :gap="4")
                template(#visible-item="{ item: group }")
                  y-chip.group-chip(:label="group.value" size="xs" outlined text-color="neutral500")
            //- cost & price
            template(v-slot:item.costPrice="{ item }")
              .yz-regular-body-xs.success500--text(v-if="item.cost_range && item.cost_range.length") Cost: {{ item.cost_range[0] | displayPrice($currency) }}
                span(v-if="item.cost_range.length > 1") &nbsp;- {{ item.cost_range[1] | displayPrice($currency) }}
              .yz-regular-body-xs.success500--text(v-if="item.price_range && item.price_range.length") Price: {{ item.price_range[0] | displayPrice($currency) }}
                span(v-if="item.price_range.length > 1") &nbsp;- {{ item.price_range[1] | displayPrice($currency) }}
            //- Stock
            template(v-slot:item.quantity="{ item }")
              .d-flex.align-center.justify-space-between(v-if="item.product.inventory_enabled")
                .text-sm.neutral700--text {{ tabs === 2 ? item.product.reserved_qty : item.product.inventory_qty }}
                yz-tooltip
                  template(#tooltip)
                    template(v-if="tabs === 2")
                      div On hand: {{ item.product.inventory_qty || 0 }}
                      div Available: {{ item.product.available_qty || 0 }}
                      div Committed: {{ item.product.committed_qty || 0 }}
                      div Incoming: {{ item.product.preorder_qty || 0 }}
                      div To order: {{ item.product.to_order_qty || 0 }}
                    template(v-else)
                      div On hand: {{ item.product.inventory_qty || 0 }}
                      div Available: {{ item.product.available_qty || 0 }}
                      div Reserved: {{ item.product.reserved_qty || 0 }}
                      div Committed: {{ item.product.committed_qty || 0 }}
                      div Incoming: {{ item.product.preorder_qty || 0 }}
                      div To order: {{ item.product.to_order_qty || 0 }}
                  yz-icon.mb-1(size="14" color="neutral500") $yzi-info-circle
            //- Expiry date
            template(v-slot:item.expiryDate="{ item }")
              div(v-if="item.nearest_expiry_date || item.latest_expiry_date")
                .yz-regular-body-xs.neutral700--text(v-if="item.nearest_expiry_date") Nearest: {{ item.nearest_expiry_date | humanizeDate }}
                .yz-regular-body-xs.neutral700--text(v-if="item.latest_expiry_date") Latest: {{ item.latest_expiry_date | humanizeDate }}
            //- actions
            template(v-slot:item.actions="{ item, index }")
              div.d-flex.align-center.justify-space-between(@click.stop)
                v-btn(icon @click.stop="updateStock(item)")
                  v-icon $yzi-package-plus
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="editMedicine(item)")
                      v-list-item-title.text-sm.basic800--text Edit item
                    v-divider
                    v-list-item(@click="onViewReservation(item)")
                      v-list-item-title.text-sm.basic800--text View reservation
                    v-divider
                    v-list-item(@click="goToStockHistory(item)")
                      v-list-item-title.text-sm.basic800--text Stock history
                    v-divider(v-if="!item.product.branch_for")
                    v-list-item(v-if="!item.product.branch_for" @click="updateStatus(item)")
                      v-list-item-title.text-sm(:class="item.product.status === 'published' ? 'danger500--text' : 'success500--text'") {{ item.product.status === 'published' ? 'Archive' : 'Activate' }}
                    template(v-if="item.product.status === 'draft' && !item.product.branch_for")
                      v-divider
                      v-list-item(@click="deleteMedicine(item)")
                        v-list-item-title.text-sm.danger500--text Delete item
        div.fill-width
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show item" attach menu-top @input="pageChanged" @pageSizeChanged="fetchFirstPage")
  y-sorter(v-model="ordering" :headers="headers" :sort-by="sortBy" :is-desc="sortIsDesc")
  .dialogs
    update-stock-dialog(v-if="openUpdateStockDialog" :open.sync="openUpdateStockDialog" :stock-count="selectedStockCount" :product="selectedProduct" :show-product-name="true" @update="stockUpdated()" @closed="closeUpdateStock()")
    purchase-hub-intro-dialog(v-if="openPurchaseHubIntroDialog" :open.sync="openPurchaseHubIntroDialog")
    delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete")
      .text-lg.font-medium Are you sure you want to delete this medicine?
      .text-md.mt-4 This action will be done immediately and can't be undone. Click "Confirm" to proceed
    view-reservation-dialog(v-if="openViewReservationDialog" :open.sync="openViewReservationDialog" :medication="selectedMedicine")
    archive-inventory-warning-dialog(v-if="openArchiveWarningDialog" v-model="openArchiveWarningDialog" :type="archiveWarningType")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import UpdateStockDialog from '@/components/clinic/inventory/UpdateStockDialog.vue'
import PurchaseHubIntroDialog from '@/components/clinic/inventory/PurchaseHubIntroDialog.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'
import ViewReservationDialog from '@/components/clinic/inventory/ViewReservationDialog.vue'
import ArchiveInventoryWarningDialog from '@/components/clinic/inventory/ArchiveInventoryWarningDialog.vue'
import FilterRow from '@/components/clinic/inventory/FilterRow.vue'
import YSorter from '@/components/YSorter.vue'

export default {
  name: 'Inventory',
  components: {YSorter, CustomizeColumnMenu, UpdateStockDialog, PurchaseHubIntroDialog, DeleteConfirmationDialog, FilterRow, ViewReservationDialog, ArchiveInventoryWarningDialog },
  props: ['savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    isChecking: false,
    showSearchField: false,
    showRegisterDialog: false,
    openUpdateStockDialog: false,
    openPurchaseHubIntroDialog: false,
    openDeleteDialog: false,
    openViewReservationDialog: false,
    openArchiveWarningDialog: false,
    archiveWarningType: 'reservation',
    searchText: null,
    tabs: 0,
    selectedStockCount: 0,
    selectedProduct: null,
    selectedMedicine: null,
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    medicines: [],
    filters: [],
    isDownloading: false,
    sortBy: null,
    sortIsDesc: false,
    ordering: null,
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      inventoryFields: 'clinic/getInventoryFields',
      canCreateInventory: 'hq/canCreateInventory'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Name', value: 'name', enable: true, sort_query_param: 'product__name', width: '20%' }
      const fields = this.inventoryFields.filter(item => item.enable).map(item => ({
        text: item.id === 'quantity' && this.tabs === 2 ? 'Reserved' : item.field_name,
        value: item.id,
        ...(item.sort_query_param ? { sort_query_param: item.sort_query_param } : {}),
        ...(item.sortable === false ? { sortable: false } : {}),
        ...(item.id === 'quantity' ? { width: this.tabs === 2 ? 110 : 120 } : item.width ? { width: item.width } : {})
      }))
      const actions = { text: '', value: 'actions', enable: true, sortable: false, width: 100 }
      return [name, ...fields, actions]
    },
    canDownload () {
      if (this.totalCount > 0) {
        return true
      }
      return false
    }
  },
  watch: {
    filters () {
      if (this.isChecking) {
        this.fetchMedicineList()
      } else {
        this.fetchFirstPage()
      }
    },
    ordering (val) {
      this.currentPage = 1
      if (val === null || val === undefined) {
        localStorage.removeItem('yz_inventory_ordering')
      } else {
        localStorage.setItem('yz_inventory_ordering', val)
      }
      if (!this.isChecking) {
        this.fetchMedicineList()
      }
    }
  },
  mounted () {
    this.checkProps()
    this.checkOrdering()
    this.headers.map(item => item['class'] = 'text-table-header')
    if (this.saveFilters) {
      this.$refs.filter.setFilters()
    } else {
      this.fetchMedicineList()
    }
    if (this.company.branch_of) {
      this.$store.dispatch('hq/fetchInventorySettings', {
        axios: this.$axios,
        hqId: this.company.branch_of.id
      })
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    checkOrdering () {
      const savedOrdering = localStorage.getItem('yz_inventory_ordering')
      if (savedOrdering) {
        this.ordering = savedOrdering
      }
    },
    fetchMedicineList () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage,
        status: 'published',
        ordering: this.ordering
      }
      if (this.tabs === 1) { params.stock__gt = 0 }
      if (this.tabs === 2) { params.reserved = true }
      if (this.tabs === 3) { params.low_stock = true }
      if (this.tabs === 4) { params.stock__lte = 0 }
      if (this.tabs === 5) { params.expire_soon = true }
      if (this.tabs === 6) { params.status = 'draft' }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/clinics/${this.company.slug}/medications`, { params })
        .then(resp => {
          this.medicines = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message && message.includes('Invalid page')) {
            this.fetchFirstPage()
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            this.medicines = []
            this.totalCount = 0
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchMedicineList()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    pageChanged () {
      this.fetchMedicineList()
    },
    tabChanged () {
      this.searchText = null
      this.fetchFirstPage()
    },
    checkProps () {
      this.isChecking = true
      if (this.saveSearch) {
        this.searchText = this.saveSearch
        this.clickSearch()
      }
      if (this.savePage) {
        this.currentPage = this.savePage
      }
      if (this.saveTab) {
        this.tabs = this.saveTab
      }
      setTimeout(() => {
        this.isChecking = false
      }, 2000)
    },
    updateStock (item) {
      this.selectedStockCount = item.product.inventory_qty
      this.selectedProduct = item.product
      this.openUpdateStockDialog = true
    },
    stockUpdated () {
      this.closeUpdateStock()
      this.fetchMedicineList()
    },
    closeUpdateStock () {
      this.selectedStockCount = 0
      this.selectedProduct = null
      this.openUpdateStockDialog = false
    },
    bulkStockUpdate () {
      // this.$router.push('/admin/clinic/stock-update')
      if (this.Auth('page', '/admin/clinic/purchase-hub')) {
        this.openPurchaseHubIntroDialog = true
      } else {
        this.$router.push('/admin/clinic/stock-update')
      }
    },
    addNewMedicine () {
      this.$router.push('/admin/clinic/medication')
    },
    editMedicine (item) {
      let params = {
        id: item.id,
        origin: 'ClinicInventory',
        data: {
          params: {
            savePage: this.currentPage,
            saveTab: this.tabs,
            saveSearch: this.searchText,
            saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
          }
        }
      }
      this.$router.push({ name: 'EditClinicMedication', params })
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    goToStockHistory (item) {
      let params = {
        id: item.id,
        origin: 'ClinicInventory',
        data: {
          params: {
            savePage: this.currentPage,
            saveTab: this.tabs,
            saveSearch: this.searchText,
            saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
          }
        }
      }
      this.$router.push({ name: 'StockHistory', params })
    },
    updateStatus (item) {
      if (item.product.status === 'published') {
        if (item.product.reserved_qty > 0) {
          this.archiveWarningType = 'reservation'
          this.openArchiveWarningDialog = true
          return
        }
        if (item.product.preorder_qty > 0) {
          this.archiveWarningType = 'preorder'
          this.openArchiveWarningDialog = true
          return
        }
      }
      this.isFetching = true
      let data = {
        product: {
          status: item.product.status === 'published' ? 'draft' : 'published'
        }
      }
      this.$axios.patch(`/clinics/${this.company.slug}/medications/${item.id}`, data)
        .then(() => {
          this.fetchMedicineList()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    confirmDelete () {
      this.isLoading = true
      this.$axios.delete(`/clinics/${this.company.slug}/medications/${this.selectedMedicine.id}`)
        .then(() => {
          this.reset()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onViewReservation (item) {
      this.selectedMedicine = item
      this.openViewReservationDialog = true
    },
    deleteMedicine (item) {
      this.selectedMedicine = item
      this.openDeleteDialog = true
    },
    reset () {
      this.fetchFirstPage()
      this.closed()
    },
    closed () {
      this.selectedMedicine = null
      this.openDeleteDialog = false
    },
    getStockUnit (item) {
      if (!item.product) return ''
      const p = item.product
      if (p.uom_conversion_enabled && p.uom_conversions && p.uom_conversions.length) {
        return p.uom_conversions[p.uom_conversions.length - 1].convert_to || ''
      }
      return p.uom || ''
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.medicines.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
    async onDownload (type) {
      this.isDownloading = true
      // Get key first
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isDownloading = false
        return
      }
      // Open download url
      let baseUrl
      if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      } else {
        baseUrl = 'https://export-test.yezza.io'
      }
      // Url setup
      let url = `${baseUrl}/clinics/${this.company.slug}/medications/preview_document`

      url = new URL(url)
      // Set key
      url.searchParams.set('key', key)
      // Prepare data
      const params = {
        status: 'published',
        export: type
      }
      if (this.tabs === 1) { params.stock__gt = 0 }
      if (this.tabs === 2) { params.reserved = true }
      if (this.tabs === 3) { params.low_stock = true }
      if (this.tabs === 4) { params.stock__lte = 0 }
      if (this.tabs === 5) { params.expire_soon = true }
      if (this.tabs === 6) { params.status = 'draft' }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      for (const objKey in params) {
        url.searchParams.set(objKey, params[objKey])
      }
      // Download
      window.open(url, '_blank')
      this.isDownloading = false
    }
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
.group-chip {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.unset-min-width {
  min-width: unset !important;
}
</style>